import { useAtom } from "jotai/react";
import { ShowBottomNavigationStore } from "../../../legacy/stores/layout/show-bottom-navigation.store";
import { ShowHeaderStore } from "../../../legacy/stores/layout/show-header.store";
import { ShowSidebarStore } from "../../../legacy/stores/layout/show-sidebar.store";

function useShowLayoutComponentsStore() {
  const [showHeaderStore, setShowHeaderStore] = useAtom(ShowHeaderStore);
  const [showBottomNavigationStore, setShowBottomNavigationStore] = useAtom(ShowBottomNavigationStore);
  const [showSidebarStore, setShowSidebarStore] = useAtom(ShowSidebarStore);

  return {
    showHeaderStore,
    showBottomNavigationStore,
    showSidebarStore,
    setShowHeaderStore,
    setShowBottomNavigationStore,
    setShowSidebarStore,
  };
}

export default useShowLayoutComponentsStore;
